import Image from 'next/image'
/*
import emailjs from 'emailjs-com'
import { Formik, Form } from 'formik'
import React, { useCallback, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'

import TextBox from '@/components/TextBox'
import TextArea from '@/components/TextArea'

import validationSchema from '@/validations/get-in-touch'
*/

import 'react-toastify/dist/ReactToastify.css'

const GetInTouch = ({ currentSection }) => {
    // const [loader, setLoader] = useState(false)

    const email = 'info@amancogrp.com'
    const phoneNumber1 = '+922135046962'
    const phoneNumber2 = '+922135040015'

    /*
    const initialState = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    }

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        setLoader(true)
        try {
            const templateParams = {
                name: `${values.firstName} ${values.lastName}`,
                email: values.email,
                phone: values.phone,
                message: values.message,
            }

            const response = await emailjs.send(
                process.env.NEXT_PUBLIC_EMAIL_SERVICE_ID,
                process.env.NEXT_PUBLIC_EMAIL_TEMPLATE_ID,
                templateParams,
                process.env.NEXT_PUBLIC_EMAIL_API_KEY
            )

            if (response.status === 200) {
                resetForm()
                toast.success('Thank you for contacting us!', {})
            }
        } catch (error) {
            // eslint-disable-next-line
            console.error('Error:', error)
        }
        setLoader(false)
    }, [])
    */

    return (
        <section
            id="section-get-fin-touch"
            className={`section bg-[url('/hero-bg.png')] bg-center text-common-white ${currentSection}`}
        >
            <div className="container">
                <div className="flex justify-center gap-16">
                    <div className="text-wrap flex max-w-[1060px] flex-col items-center justify-center text-center mobile:max-w-[404px]">
                        <h2 className="h1">Get in touch</h2>
                        <p className="mb-12 text-2xl leading-9 text-interface-300 ipad:mb-6 ipad:text-xl mobile:text-base">
                            Contact us today to learn more about our products
                            and services, or to request a quote.
                        </p>
                        <div className="max-w-[700px] text-center mobile:w-[360px]">
                            <ul>
                                <li className="mb-6 flex justify-center">
                                    <i className="mr-3 h-6 w-6 flex-shrink-0">
                                        <Image
                                            src="/icons/email-icon.svg"
                                            alt="email"
                                            width={24}
                                            height={24}
                                        />
                                    </i>
                                    <span>
                                        Email:
                                        <a
                                            className="ml-2 text-common-white underline"
                                            href={`mailto:${email}`}
                                        >
                                            {email}
                                        </a>
                                    </span>
                                </li>
                                <li className="mb-6 flex justify-center">
                                    <i className="mr-3 h-6 w-6 flex-shrink-0">
                                        <Image
                                            src="/icons/phone-icon.svg"
                                            alt="phone"
                                            width={24}
                                            height={24}
                                        />
                                    </i>
                                    <span>
                                        Phone:
                                        <a
                                            className="ml-2 text-common-white"
                                            href={`tel:${phoneNumber1}`}
                                        >
                                            {phoneNumber1}
                                        </a>
                                        ,
                                        <a
                                            className="ml-2 text-common-white"
                                            href={`tel:${phoneNumber2}`}
                                        >
                                            {phoneNumber2}
                                        </a>
                                    </span>
                                </li>
                                <li className="flex justify-center">
                                    <i className="mr-3 h-6 w-6 flex-shrink-0">
                                        <Image
                                            src="/icons/location-icon.svg"
                                            alt="location"
                                            width={30}
                                            height={30}
                                        />
                                    </i>
                                    <span className="w-fit">
                                        Plot No. 18, Sector-28, Korangi
                                        Industrial Area, Karachi-74900.
                                        Pakistan.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* Contact form */}
                    {/*
                    <div className="w-full">
                        <div>
                            <p className="mb-6 font-medium">
                                Please fill out the form below and we&apos;ll
                                get back to you soon.
                            </p>
                        </div>
                        <Formik
                            onSubmit={handleSubmit}
                            initialValues={initialState}
                            validationSchema={validationSchema}
                            validateOnBlur={false}
                        >
                            {() => {
                                return (
                                    <Form noValidate>
                                        <div className="grid grid-cols-2 gap-6 mobile:grid-cols-1 mobile:gap-0">
                                            <TextBox
                                                id="firstName"
                                                label="First Name:"
                                                placeholder="Enter your first name"
                                            />
                                            <TextBox
                                                id="lastName"
                                                label="Last Name:"
                                                placeholder="Enter your last name"
                                            />
                                        </div>
                                        <div className="grid grid-cols-2 gap-6 mobile:grid-cols-1 mobile:gap-0">
                                            <TextBox
                                                id="email"
                                                type="email"
                                                label="Work Email:"
                                                placeholder="Enter your work email address"
                                            />
                                            <TextBox
                                                id="phone"
                                                type="tel"
                                                label="Phone Number:"
                                                placeholder="Enter your phone number"
                                            />
                                        </div>
                                        <div>
                                            <TextArea
                                                id="message"
                                                label="Message:"
                                                placeholder="Start typing your message"
                                            />
                                        </div>
                                        <div className="flex items-center mobile:flex-col">
                                            <div className="mr-3 w-[107px] flex-shrink-0 mobile:m-0 mobile:w-full ">
                                                <button
                                                    className="btn "
                                                    type="submit"
                                                >
                                                    {!loader && (
                                                        <span>Submit</span>
                                                    )}
                                                    {loader && (
                                                        <div>
                                                            <div className="loader">
                                                                Loading...
                                                            </div>
                                                        </div>
                                                    )}
                                                </button>
                                            </div>
                                            <ToastContainer
                                                position="bottom-right"
                                                autoClose={5000}
                                                hideProgressBar={false}
                                                newestOnTop={false}
                                                closeOnClick
                                                rtl={false}
                                                pauseOnFocusLoss
                                                draggable
                                                pauseOnHover
                                                theme="colored"
                                            />
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                    */}
                </div>
            </div>
        </section>
    )
}

export default GetInTouch
